module.exports = __webpack_public_path__ + "static/media/waterpark3.43e064ae.jpg";